import { post, get } from "../request";

// 获取题目统计
export function getQuestionAnswerStatic(data) {
  return get("/v1/live/getQuestionAnswerStatic", data);
}
// 获取答题概览统计
export function getQuestionStaticData(data) {
  return get("/v1/live/getQuestionStaticData", data);
}

// 获取学生答题详情
export function getStudentAnswerDetail(data) {
  return get("/v1/live/getStudentAnswerDetail", data);
}
// 获取答题统计
export function getStudentAnswerStatic(data) {
  return get("/v1/live/getStudentAnswerStatic", data);
}
// 获取学生排名
export function getStudentRankList(data) {
  return get("/v1/live/getStudentRankList", data);
}
// 获取缺席
export function getAbsenceStudentList(data) {
  return get("/v1/live/getAbsenceStudentList", data);
}
// 获取出勤学生
export function getAttendanceStudentList(data) {
  return get("/v1/live/getAttendanceStudentList", data);
}
